import api from "@/apis/JobPositionAPI";
import Crud from "./crud-base";
import httpClient from "@/apis/base/axios-httpclient";
var crud = new Crud("JobPosition", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "JobPositionID",
      code: "JobPositionCode",
      name: "JobPositionName",
    },
  },
};
const getters = {
  ...crud.getters,
};

/**
 * Đồng bộ dữ liệu từ AMIS Hệ thống
 * @author: NTAnh2 (24/03/2021)
 */
const actions = {
  ...crud.actions,
  syncJobPositionFromAMIS: async function () {
    let request = {
      url: [api.getAPIUrl(), "sync_jobPosition"].join("/"),
    };
    return await httpClient.getAsync(request);
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
